/**
 * Plugin that draws crosshair guide lines following the active tooltip point.
 */
export const crosshairGuidesPlugin = {
    id: 'crosshairGuides',
    afterDraw(chart) {
        const { ctx, chartArea, tooltip } = chart;
        if (!tooltip?.getActiveElements().length) return;

        const { x, y } = tooltip.getActiveElements()[0].element;

        ctx.save();
        ctx.setLineDash([5, 5]);
        ctx.lineWidth = 1;
        ctx.strokeStyle = '#999';

        // Vertical line
        ctx.beginPath();
        ctx.moveTo(x, chartArea.top);
        ctx.lineTo(x, chartArea.bottom);
        ctx.stroke();

        // Horizontal line
        ctx.beginPath();
        ctx.moveTo(chartArea.left, y);
        ctx.lineTo(chartArea.right, y);
        ctx.stroke();

        ctx.restore();
    },
};